import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useAuth } from 'contexts/AuthContext';

const WelcomeMessage = () => {
  const { user } = useAuth();

  // Don't show if no user data
  if (!user) {
    return null;
  }

  // Get display name (prefer firstName, fallback to username)
  const displayName = user.firstName || user.username || 'User';
  
  return (
    <Card className="mb-4 mt-3 border-1 shadow-sm">
      <Card.Body className="p-4">
        <Row className="align-items-center">
          <Col>
            <div className="d-flex align-items-center">
              <div className="flex-1">
                <h4 className="mb-1 text-primary">
                  Welcome back, {displayName}! 
                </h4>
                <p className="text-muted mb-0" style={{fontSize: 13}}>
                  Live operations overview for tasks, users, and projects.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default WelcomeMessage;
